import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import CircularProgress from "@mui/material/CircularProgress";
import ReplayIcon from "@mui/icons-material/Replay";

import { ATTENDANCE_OPTIONS, statusHex, isMarked } from "../attendanceHelpers";
import ClientLevelPills from "./ClientLevelPills";

// One client's attendance controls — shared by the dashboard AttendanceDialog
// and the full-schedule BookingSheet. The caller owns the optimistic state and
// the API call; this only renders name + levels + toggle group + undo.
function AttendanceRow({ client, value, saving, disabled, onSet }) {
  const marked = isMarked(value);
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ fontWeight: 600 }}>
              {client.name || "Client"}
            </Typography>
            <ClientLevelPills levels={client.levels} withDescriptions sx={{ mt: 0.5 }} />
          </Box>
          {saving && <CircularProgress size={14} />}
        </Box>
        {marked && !disabled && (
          <Button
            size="small"
            color="inherit"
            startIcon={<ReplayIcon />}
            disabled={saving}
            onClick={() => onSet(client, "NEW")}
            sx={{ flexShrink: 0, minWidth: 0, color: "text.secondary" }}
          >
            Undo
          </Button>
        )}
      </Box>
      <ToggleButtonGroup fullWidth size="small" exclusive value={marked ? value : null} onChange={(_, next) => onSet(client, next)}>
        {ATTENDANCE_OPTIONS.map((o) => (
          <ToggleButton
            key={o.value}
            value={o.value}
            disabled={saving || disabled}
            sx={{
              flex: 1,
              whiteSpace: "nowrap",
              "&.Mui-selected": { bgcolor: statusHex(o.value), color: "#fff" },
              "&.Mui-selected:hover": { bgcolor: statusHex(o.value) }
            }}
          >
            {o.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}

export default AttendanceRow;
